// extracted by mini-css-extract-plugin
export default {"page":"styles_page__yU0Wa","outside":"styles_outside__a2bOy","underground":"styles_underground__+7KJG","answerButtons":"styles_answerButtons__D3guf"};